import { Box, Typography } from '@mui/material';
import React, { FC, ReactNode } from 'react';

type BoxWithTitleProps = {
    title: string;
    children: ReactNode;
};

const BoxWithTitle: FC<BoxWithTitleProps> = ({ title, children }: BoxWithTitleProps) => {
    return (
        <Box
            sx={{
                border: '1px solid #ccc',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
                backgroundColor: '#f8f8f8',
            }}
        >
            <Typography
                variant="h6"
                sx={{
                    marginBottom: '8px',
                    fontWeight: 'bold',
                    color: '#333',
                }}
            >
                {title}
            </Typography>
            {children}
        </Box>
    );
};

export default BoxWithTitle;
